licenses-notices-1 = 本程式是自由軟體：您可以根據GNU Affero General Public License的條款重新發佈和/或修改它。您可以根據自由軟體基金會發佈的GNU Affero通用公共許可的條款來重新發佈和/或修改它。您可以根據自由軟體基金會發佈的GNU Affero通用公共許可的條款重新發佈和/或修改它。許可，或（根據您的選擇）任何後來的版本。
licenses-notices-2 = 本程式的發佈是希望它能起到作用。但沒有任何保證；甚至沒有隱含的保證。本程式的分發是希望它是有用的，但沒有任何保證，甚至沒有隱含的適銷對路或適合某一特定目的的保證。 參見 GNU Affero通用公共許可瞭解更多細節。
licenses-notices-3 = 您應該已經收到了一份GNU Affero通用公共許可的副本。的副本。 如果沒有，請參見https://www.gnu.org/licenses/。
copyright-notices = 
    版權所有 2025 Tnze. All Rights Reserved.
    引用的FFXIV相關資源 Copyright © 2010 - 2025 SQUARE ENIX CO., LTD.
    繁化-Isla
level = 等級
recipe-level = 配方等級
class-job-level = 特職等級
craftsmanship = 作業精度
control = 加工精度
craft-point = CP(製作力)
progress = 進展
quality = 品質
durability = 耐久
steps = 工次
condition = 狀態
difficulty = 難度
initial-quality = 初期品質
conditions = 製作狀態
progress-divider = 作業難度係數
progress-modifier = 作業壓制係數
quality-divider = 加工難度係數
quality-modifier = 加工壓制係數
difficulty-factor = 配方難度係數
quality-factor = 配方品質係數
durability-factor = 配方耐久係數
material-quality-factor = 半成品品質貢獻度

meals = 食品
medicines = 藥品

name = 名稱
amount = 數量

specialist = 專家

# 職業名
carpenter = 木工師
blacksmith = 鍛造師
armorer = 甲冑師
goldsmith = 金工師
leatherworker = 皮革師
weaver = 裁縫師
alchemist = 鍊金術士
culinarian = 烹調師

# 配裝名稱
default = 預設
common = 通用
custom = 自定義 { $id }

# 技能名
basic-synthesis = 製作
basic-touch = 加工
masters-mend = 精修
hasty-touch = 倉促
rapid-synthesis = 高速製作
observe = 觀察
tricks-of-the-trade = 秘訣
waste-not = 儉約
veneration = 崇敬
standard-touch = 中級加工
great-strides = 闊步
innovation = 改革
final-appraisal = 最終確認
waste-not-ii = 長期儉約
byregot-s-blessing = 比爾格的祝福
precise-touch = 集中加工
muscle-memory = 堅信
careful-synthesis = 模範製作
manipulation = 掌握
prudent-touch = 儉約加工
reflect = 閒靜
preparatory-touch = 坯料加工
groundwork = 坯料製作
delicate-synthesis = 精密製作
intensive-synthesis = 集中製作
trained-eye = 工匠的神速技巧
advanced-touch = 上級加工
prudent-synthesis = 儉約製作
trained-finesse = 工匠的神技
careful-observation = 設計變動
heart-and-soul = 專心致志
refined-touch = 精煉加工
daring-touch = 冒進
immaculate-mend = 巧奪天工
quick-innovation = 快速改革
trained-perfection = 工匠的絕技

# 技能描述
desc-basic-synthesis = 推動進展，效率：100，31級後效率：120。
desc-basic-touch = 提高品質，效率：100。
desc-masters-mend = 恢復30點耐久。
desc-hasty-touch = 提高品質，效率：100，不消耗CP，成功率：60%。
desc-rapid-synthesis = 推動進展，效率：250，63級後效率：500，成功率：50%。
desc-observe = 放空一次作業，用於連擊注視製作和注視加工。
desc-tricks-of-the-trade = 恢復20點CP，只有在“高品質”及以上的狀態下才能使用。
desc-waste-not = 耐久度的消耗量減少50%，持續4次作業。
desc-veneration = 推動進展的技能效率提高50%，持續4次作業。
desc-standard-touch = 提高品質，效率：125，與加工連擊可降低CP消耗。
desc-great-strides = 令下一次使用的加工系技能效果變為2倍，3次作業內有效。
desc-innovation = 提升品質的技能效率提高50%，持續4次作業。
desc-final-appraisal = 執行推進作業進度的技能時，讓作業進度接近於完成時停止一次，5次作業內有效。
desc-waste-not-ii = 耐久度的消耗量減少50%，持續8次作業。
desc-byregot-s-blessing = 消耗內靜提高品質，效率100~300，每檔內靜提升20效率。
desc-precise-touch = 提高品質，效率：150，提供兩檔內靜，只有在“高品質”及以上的狀態下才能使用。
desc-muscle-memory = 僅可在首次作業時發動，推動進展，效率：300，令下一次使用的製作系技能效果翻倍，5次作業內有效。
desc-careful-synthesis = 推動進展，效率：150，82級後效率：180。
desc-manipulation = 每次作業結束時恢復5點耐久，持續8次作業。
desc-prudent-touch = 提高品質，效率：100，只消耗5點耐久，無法在儉約狀態下使用。
desc-reflect = 僅可在首次作業時發動，提高品質，效率：300，提供兩檔內靜。
desc-preparatory-touch = 提高品質，效率：200，提供兩檔內靜，消耗20點耐久。
desc-groundwork = 推動進展，效率：300，86級後效率：360，消耗20點耐久，耐久不足時效率減半。
desc-delicate-synthesis = 推動進展並提高品質，效率：100，94級後提高進展效率：150。
desc-intensive-synthesis = 推動進展，效率：400，只有在“高品質”及以上的狀態下才能使用。
desc-trained-eye = 僅可在首次作業且用於等級低了10級及以上的配方時發動，提高最大品質的100%
desc-advanced-touch = 提高品質，效率：150，與中級加工連擊可降低CP消耗。
desc-prudent-synthesis = 推動進展，效率：180，只消耗5點耐久，無法在儉約狀態下使用。
desc-trained-finesse = 只有內靜的檔數為10時才可以使用，提高品質，效率：100，不消耗耐久。
desc-careful-observation = 消耗一個能工巧匠圖紙，改變作業狀態，一次製作最多可使用3次，目前計算器UI不支援切換製作狀態。
desc-heart-and-soul = 消耗一個能工巧匠圖紙，允許使用一次集中加工、集中製作或秘訣，一次製作最多可使用1次。

desc-refined-touch = 提高品質，效率：100，與加工連擊可以額外獲得一層內靜。
desc-daring-touch = 提高品質，效率：150，不消耗CP，成功率：60%。
desc-immaculate-mend = 耐久恢復到最大值。
desc-quick-innovation = 獲得改革狀態，持續1次作業，一次製作最多可使用1次。
desc-trained-perfection = 下一個會消耗耐久的技能耐久消耗變為0，一次製作最多可使用1次。

# 技能釋放錯誤
DurabilityNotEnough = 耐久不足
CraftPointNotEnough = CP不足
CraftingAlreadyFinished = 製作已完成無法發動技能
PlayerLevelTooLow = 該技能尚未學會，玩家等級不足
RequireGoodOrExcellent = 該技能只有在“高品質”及以上的狀態下才能使用
NotAllowedInWastNotBuff = 該技能在儉約及長期簡約狀態下無法使用
OnlyAllowedInFirstStep = 該技能僅可在首次作業時發動
LevelGapMustGreaterThanTen = 該技能僅可在首次作業且用於等級低了10級及以上的配方時發動
RequireInnerQuiet1 = 該技能只有在內靜的檔數大於1時才可以使用
RequireInnerQuiet10 = 該技能只有在內靜的檔數為10時才可以使用
CarefulObservationUsed3 = 設計變動最多使用三次
HeartAndSoulUsed = 專心致志一次製作只能使用一次
FocusNeverFailsAfterObserved = 注視在觀察之後無法失敗
RequireHastyTouchSuccessed = 必須在倉促成功後使用
QuickInnovationUsed = 快速改革一次製作只能使用一次
NotAllowedInInnovationBuff = 改革狀態下無法發動快速改革
TrainedPerfectionUsed = 工匠的絕技一次製作只能使用一次

# 狀態
normal = 通常
good = 高品質
excellent = 最高品質
poor = 低品質
centered = 安定
sturdy = 結實
pliant = 高效
malleable = 大進展
primed = 長持續
goodomen = 好兆頭

# 更新器
update-available = 更新可用：v{ $version }
update-now = 現在更新
update-not-now = 下次再說
update-installing = 正在安裝更新，請耐心等待
update-ask-relaunch = 更新已安裝，是否重啟應用？

update-pending = 正在更新中
update-error = 更新失敗：{ $error }
update-done = 更新已完成
update-uptodate = 已是最新版本

update-started = 更新下載開始
update-progress = 更新下載中：{ $progress }
update-done = 更新下載結束

# Rust Errors
player-level-lower-than-recipe-requirement = 玩家等級未達到所選配方最低要求
unknown-recipe-level = 遇到了資料庫中不存在的配方等級
solver-already-exist = 求解器已存在
solver-is-creating = 求解器已正在建立中
solver-doesn-t-exist = 求解器不存在
solver-isn-t-prepared = 求解器未準備完成

# Titles
attributes = 裝備屬性
select-recipe = 選擇配方
custom-recipe = 自定義配方
bill-of-material = 物料清單
settings = 設定
